import React from 'react';
import { makeStyles, Theme, Grid } from '@material-ui/core';
import WaitingIcon from '@material-ui/icons/AccessTime';
import InterestedIcon from '@material-ui/icons/Check';
import PassedIcon from '@material-ui/icons/Clear';
import { useHistory } from 'react-router';
import clsx from 'clsx';
import { StyledText } from '../../../../components/StyledText';
import { MatchListType } from '../../../../types/types';

const useStyles = makeStyles<Theme>(({ palette }: Theme) => ({
  root: {
    margin: 0
  },
  leftBorder: {
    backgroundColor: '#DAD9DF',
    width: '1px',
    marginRight: '15px'
  },
  referralLine: {
    display: 'flex',
    alignItems: 'center',
    padding: '7px 0'
  },
  icon: {
    width: '18px',
    height: '18px',
    marginRight: '10px'
  },
  waiting: {
    color: palette.info.main
  },
  interested: {
    color: palette.success.main
  },
  passed: {
    color: palette.error.main
  },
  seeAll: {
    cursor: 'pointer'
  },
  flexRow: {
    display: 'flex'
  },
  flexCol: {
    display: 'flex',
    flexDirection: 'column'
  }
}));

export interface InProgressInvestorsPanelProps {
  recommendedInvestorsCount: number;
  sentInvestors: {
    waitingCount: number;
    interestedCount: number;
    passedCount: number;
  };
  entProfileId: number;
}

export const InProgressInvestorsPanel: React.FC<InProgressInvestorsPanelProps> = ({
  recommendedInvestorsCount = 0,
  sentInvestors,
  entProfileId
}) => {
  const styles = useStyles();
  const history = useHistory();
  const totalSentCount = sentInvestors.waitingCount + sentInvestors.interestedCount + sentInvestors.passedCount;
  return (
    <Grid container justify='space-between' className={styles.root} spacing={1}>
      <Grid item xs={12}>
        <div className={styles.flexRow}>
          <StyledText variant='h3' component='div'>
            Recommended Referrals &nbsp;
          </StyledText>
          <StyledText variant='counter' color='primary'>
            {Math.max(0, recommendedInvestorsCount - totalSentCount)}
          </StyledText>
        </div>
        {recommendedInvestorsCount > 0 && (
          <div className={styles.flexRow} style={{ marginTop: '6px' }}>
            <StyledText variant='link' color='secondary' className={styles.seeAll} onClick={() => history.push(`/entrepreneur/${entProfileId}/matched-investors/recommended`)}>
              See all &gt;
            </StyledText>
          </div>
        )}
        <div className={styles.flexRow} style={{ marginTop: '35px' }}>
          <StyledText variant='h3' component='div'>
            Sent Referrals &nbsp;
          </StyledText>
          <StyledText variant='counter' color='primary'>
            {totalSentCount}
          </StyledText>
        </div>
        <div className={styles.flexRow} style={{ marginTop: '13px', marginBottom: '20px' }}>
          <div className={styles.leftBorder} />
          <div className={styles.flexCol}>
            <div className={styles.referralLine}>
              <WaitingIcon className={clsx(styles.icon, styles.waiting)} />
              <StyledText variant='body1' component='span'>
                Waiting &nbsp;
              </StyledText>
              <StyledText variant='counterSmall' className={styles.waiting} component='span'>
                {sentInvestors.waitingCount}
              </StyledText>
            </div>
            <div className={styles.referralLine}>
              <InterestedIcon className={clsx(styles.icon, styles.interested)} />
              <StyledText variant='body1' component='span'>
                Interested &nbsp;
              </StyledText>
              <StyledText variant='counterSmall' className={styles.interested} component='span'>
                {sentInvestors.interestedCount}
              </StyledText>
            </div>
            <div className={styles.referralLine}>
              <PassedIcon className={clsx(styles.icon, styles.passed)} />
              <StyledText variant='body1' component='span'>
                Passed &nbsp;
              </StyledText>
              <StyledText variant='counterSmall' className={styles.passed} component='span'>
                {sentInvestors.passedCount}
              </StyledText>
            </div>
          </div>
        </div>
        {totalSentCount > 0 && (
          <div className={styles.flexRow} style={{ marginTop: '6px' }}>
            <StyledText variant='link' color='secondary' className={styles.seeAll} onClick={() => history.push(`/entrepreneur/${entProfileId}/matched-investors/sent`)}>
              See all &gt;
            </StyledText>
          </div>
        )}
      </Grid>
    </Grid>
  );
};
